var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 841.89 595.28",
    viewBox: "0 0 841.89 595.28",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 841.89,
    height: 595.28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6431 0 0 1.6085 -272.69 -183.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m427.76 249.73v-76.5h24.31v75.02c0 7.56 1.63 9.79 5.93 9.79 4.6 0 5.78-2.08 5.78-9.79v-75.02h24.32v76.5c0 22.39-11.27 31.88-30.1 31.88-19.71 0-30.24-9.49-30.24-31.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m524.13 279.98h-23.87v-106.75h30.1c21.65 0 30.25 8.6 30.25 26.69v18.83c0 17.94-8.6 28.47-30.25 28.47h-6.23zm0-53.97h4.89c4.74 0 7.12-2.67 7.12-7.86v-17.2c0-5.04-2.22-7.41-6.97-7.41h-5.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m571.13 279.98v-106.75h21.79l18.83 52.19 1.63 5.93-0.44-9.64v-48.48h21.94v106.75h-21.35l-19.27-52.19-1.78-6.08 0.59 10.53v47.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m297.18 173.23v248.43h-36.31v-182.02l-1.03 0.95c-16.02 15.07-33.76 28.41-52.84 39.63v-41.08c10.01-6.98 19.47-14.68 28.38-22.98 13.84-12.91 26.27-27.3 37.05-42.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m400.83 239.14v41.08c-19.08-11.23-36.81-24.56-52.84-39.63l-1.03-0.95v182.02h-36.31v-248.43h24.75c10.78 15.63 23.22 30.02 37.05 42.93 8.9 8.3 18.36 16 28.38 22.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m432.05 329.22v-20.28h5.18v19.96c0 2.77 0.71 3.83 2.57 3.83s2.57-1.03 2.57-3.83v-19.96h5.14v20.28c0 5.93-2.73 8.5-7.71 8.5-5.14 0-7.75-2.57-7.75-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m451.38 337.29v-28.34h4.55l6.52 15.97 0.99 3.2-0.28-3.83v-15.34h4.62v28.34h-4.43l-6.68-16.09-0.99-3.4 0.32 4.23v15.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m471.11 332.46h3.32v-18.78h-3.32v-4.74h11.5v4.74h-3.24v18.78h3.24v4.82h-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m484.75 308.94h5.22l3.36 16.92 0.28 4.15 0.28-4.15 3.28-16.92h5.18l-6.17 28.34h-5.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m504.95 337.29v-28.34h13.24v4.62h-8.19v7.04h7.19v4.67h-7.19v7.23h8.42v4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m526.57 337.29h-4.94v-28.34h7.63c5.34 0 7.55 2.06 7.55 6.76v3.4c0 2.77-1.03 4.23-3 4.98 2.06 0.67 2.73 2.13 2.73 4.94v6.4c0 0.83 0.28 1.42 0.75 1.86h-5.38c-0.36-0.28-0.51-0.99-0.51-1.9v-6.13c0-2.02-0.55-2.81-2.69-2.81h-2.13v10.84zm0-15.34h2.41c2.02 0 2.81-0.91 2.81-2.81v-3.16c0-1.86-0.79-2.69-2.85-2.69h-2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m539.61 330.33v-3.8h5.3v3.72c0 1.82 0.63 2.88 2.69 2.88 1.86 0 2.49-1.15 2.49-2.73v-1.46c0-0.79-0.2-1.42-0.63-2.02-0.83-1.07-2.29-1.86-3.87-2.65-0.91-0.48-1.82-0.99-2.65-1.62-1.74-1.23-3-2.96-3-5.89v-1.18c0-4.39 2.41-7.04 7.51-7.04s7.39 2.49 7.39 6.64v3.08h-5.02v-2.77c0-1.86-0.67-2.69-2.41-2.69-1.7 0-2.37 1.11-2.37 2.81v0.79c0 0.75 0.2 1.34 0.63 1.82 0.83 0.99 2.25 1.74 3.79 2.53 0.91 0.47 1.78 1.03 2.69 1.62 1.74 1.22 3.04 3 3.04 5.97v2.17c0 4.51-2.57 7.19-7.67 7.19-5.89 0.02-7.91-2.55-7.91-7.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m557.6 332.46h3.32v-18.78h-3.32v-4.74h11.5v4.74h-3.24v18.78h3.24v4.82h-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m579.73 308.94c1.66 0 3.08 0.28 4.39 0.87 2.53 1.11 4.11 3.52 4.11 7.55v11.5c0 2.02-0.36 3.6-1.11 4.82-1.42 2.49-4.11 3.6-7.43 3.6h-7.27v-28.34zm-2.21 23.84h1.98c2.17 0 3.44-1.3 3.44-4.39v-10.67c0-3.12-1.3-4.39-3.48-4.39h-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m595.7 333.1-0.79 4.19h-5.1l6.28-28.34h5.1l6.44 28.34h-5.1l-0.83-4.19zm5.14-4.47-1.86-9.45-0.32-3.95-0.32 3.95-1.78 9.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m617.44 308.94c1.66 0 3.08 0.28 4.39 0.87 2.53 1.11 4.11 3.52 4.11 7.55v11.5c0 2.02-0.36 3.6-1.11 4.82-1.42 2.49-4.11 3.6-7.43 3.6h-7.27v-28.34zm-2.21 23.84h1.98c2.17 0 3.44-1.3 3.44-4.39v-10.67c0-3.12-1.3-4.39-3.48-4.39h-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m437.23 379.45h-5.02v-28.34h7.47c5.49 0 7.87 2.14 7.87 7.15v4.82c0 4.67-2.29 7.47-7.79 7.47h-2.53zm0-13.36h2.25c2.02 0 2.96-1.07 2.96-3.12v-4.54c0-2.17-0.91-2.96-2.96-2.96h-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m455.69 379.45h-4.94v-28.34h7.63c5.34 0 7.55 2.06 7.55 6.76v3.4c0 2.77-1.03 4.23-3 4.98 2.06 0.67 2.73 2.13 2.73 4.94v6.4c0 0.83 0.28 1.42 0.75 1.86h-5.38c-0.36-0.28-0.51-0.99-0.51-1.9v-6.13c0-2.02-0.55-2.81-2.69-2.81h-2.13v10.84zm0-15.33h2.41c2.02 0 2.81-0.91 2.81-2.81v-3.16c0-1.86-0.79-2.69-2.85-2.69h-2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m468.7 374.63h3.32v-18.78h-3.32v-4.74h11.5v4.74h-3.24v18.78h3.24v4.82h-11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m482.33 351.11h5.22l3.36 16.92 0.28 4.15 0.28-4.15 3.28-16.92h5.18l-6.17 28.34h-5.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m504.55 375.26-0.79 4.19h-5.1l6.28-28.34h5.1l6.44 28.34h-5.1l-0.83-4.19zm5.14-4.47-1.86-9.45-0.32-3.95-0.32 3.95-1.78 9.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m526.29 351.11c1.66 0 3.08 0.28 4.39 0.87 2.53 1.11 4.11 3.52 4.11 7.55v11.5c0 2.02-0.36 3.6-1.11 4.82-1.42 2.49-4.11 3.6-7.43 3.6h-7.27v-28.34zm-2.21 23.83h1.98c2.17 0 3.44-1.3 3.44-4.39v-10.67c0-3.12-1.3-4.39-3.48-4.39h-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m542.26 375.26-0.79 4.19h-5.1l6.28-28.34h5.1l6.44 28.34h-5.1l-0.83-4.19zm5.14-4.47-1.86-9.45-0.32-3.95-0.32 3.95-1.78 9.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m439.53 393.27c1.66 0 3.08 0.28 4.39 0.87 2.53 1.11 4.11 3.52 4.11 7.55v11.5c0 2.02-0.36 3.6-1.11 4.82-1.42 2.49-4.11 3.6-7.43 3.6h-7.27v-28.34zm-2.22 23.84h1.98c2.17 0 3.44-1.3 3.44-4.39v-10.67c0-3.12-1.3-4.39-3.48-4.39h-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m451.7 421.61v-28.34h13.24v4.62h-8.18v7.04h7.19v4.67h-7.19v7.23h8.42v4.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m468.38 393.27h5.22v23.24h7.59v5.1h-12.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m492.89 421.61v-28.34h4.55l6.52 15.97 0.99 3.2-0.28-3.83v-15.34h4.62v28.34h-4.43l-6.68-16.09-0.99-3.4 0.32 4.23v15.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m512.97 413.43v-11.9c0-5.81 3.2-8.62 8.18-8.62s8.18 2.81 8.18 8.62v11.9c0 5.93-3.2 8.62-8.18 8.62-5.1 0-8.18-2.65-8.18-8.62zm11.07-0.39v-11.26c0-2.96-0.83-4.31-2.89-4.31-2.13 0-2.88 1.38-2.88 4.31v11.26c0 2.93 0.75 4.27 2.88 4.27 2.06 0 2.89-1.35 2.89-4.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m537.95 421.61h-4.94v-28.34h7.63c5.34 0 7.55 2.06 7.55 6.76v3.4c0 2.77-1.03 4.23-3 4.98 2.06 0.67 2.73 2.13 2.73 4.94v6.4c0 0.83 0.28 1.42 0.75 1.86h-5.38c-0.36-0.28-0.51-0.99-0.51-1.9v-6.13c0-2.02-0.55-2.81-2.69-2.81h-2.13v10.84zm0-15.33h2.41c2.02 0 2.81-0.91 2.81-2.81v-3.16c0-1.86-0.79-2.69-2.85-2.69h-2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m560.08 421.61h-5.1v-23.68h-4.66v-4.67h14.47v4.67h-4.7v23.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m567.76 421.61v-28.34h13.24v4.62h-8.18v7.04h7.19v4.67h-7.19v7.23h8.42v4.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b98356ce257038c6f89461c8518dfa5c.svg";
export { ForwardRef as ReactComponent };